import GroupLayout from "./GroupLayout";

const adityaacademyLayout = () => (
  <GroupLayout
    brandName="Adityaacademy"
    logoUrl="https://gcc-site.s3.ap-south-1.amazonaws.com/aditya_group_of_schools_logo.jfif"
    groupId="20000000016"
    headline="Aditya Academy Group"
  />
);

export default adityaacademyLayout;
